export const donationMatchingTooltipText =
  'Donation matching is a giving initiative of an employer wherein they match their employee’s contribution.';
